export default "__VITE_ASSET__K4xzikje__"